import { render, staticRenderFns } from "./buyModal.vue?vue&type=template&id=0960b414&scoped=true"
import script from "./buyModal.vue?vue&type=script&lang=js"
export * from "./buyModal.vue?vue&type=script&lang=js"
import style0 from "./buyModal.vue?vue&type=style&index=0&id=0960b414&prod&lang=scss"
import style1 from "./buyModal.vue?vue&type=style&index=1&id=0960b414&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0960b414",
  null
  
)

export default component.exports